import { Response, ResponsePagination } from "@interfaces/response";
import { baseApi } from "./baseApi";
import { Company } from "@interfaces/companies";
import { UUID } from "crypto";

const companyApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getCompanies: build.query<Array<Company>, void>({
            query: () => ({
                url: "catalogos/company",
            }),
            transformResponse: (response: ResponsePagination<Company>) => {
                return response.data.data;
            },
        }),
        getCompany: build.query<Company, UUID>({
            query: (companyId) => ({
                url: `catalogos/company/${companyId}`,
            }),
            transformResponse: (response: Response<Company>) => {
                return response.data;
            },
        }),
    }),
});

export const { useGetCompaniesQuery, useLazyGetCompaniesQuery, useLazyGetCompanyQuery } = companyApi;
